<template>
    <div class="project-list">
        <div class="pl-title">
            <h2>My Projects</h2>
        </div>
        <div class="pl-search">
            <input type='text' v-model="plsearch" placeholder='Search...'></input>
        </div>
        <div class='pl-content'>
            <div class='pl-taglist'>
                <div class='pl-catgroup' v-for="(cat, index) in catlist" :key="index">
                    <div class='pl-cat-title'>{{cat.cname}}</div>
                    <div class='pl-cat-tags ns'>
                        <div class='pl-cat-tag-toggle' @click='ftogg(index, ti, tag)' :class="{'pl-tag-sel':tag.sel}" v-for="(tag, ti) in cat.tags" :key="ti">{{tag.name}}</div>
                    </div>
                    <hr v-if="index<catlist.length-1">
                </div>
            </div>
            <div class='pl-cards'>
                <div class='pl-notfound' v-if="f_plist.length===0">No projects found</div>
                <ProjectCard @filter_add='fadd' :data='project_data' v-for="(project_data, index) in f_plist" :key="project_data.title"/>
            </div>
        </div>

    </div>
</template>
<script>

import ProjectCard from '@/components/pl_components/ProjectCard.vue'
import { ref, computed } from 'vue'

export default {
    name: 'ProjectList',
    components: {ProjectCard},
    props: ['tags'],
    setup(props) {
        const catlist = ref([
            {
                cname:"Status",
                tags:[
                    {name:'Released', sel:false},
                    {name:'In Development', sel:false},
                    {name:'Archived', sel:false},
                    {name:'PoC', sel:false},
                ]
            },
            {
                cname:"Project Type",
                tags:[
                    {name:'Software', sel:false},
                    {name:'Hardware', sel:false},
                    {name:'Audio', sel:false},
                    {name:'Video', sel:false},
                    {name:'GameDev', sel:false},
                    {name:'Other', sel:false},
                ]
            },
            {
                cname:"Language",
                tags:[
                    {name:'GO', sel:false},
                    {name:'Bash', sel:false},
                    {name:'HTML/CSS', sel:false},
                    {name:'Python', sel:false},
                    {name:'JavaScript', sel:false},
                    {name:'NodeJS', sel:false},
                    {name:'TypeScript', sel:false},
                    {name:'C++', sel:false},
                    {name:'C#', sel:false},
                    {name:'C', sel:false},
                    {name:'Java', sel:false},
                    {name:'Kotlin', sel:false},
                    {name:'ASM', sel:false},
                    {name:'PHP', sel:false},
                    {name:'PowerShell', sel:false},
                    {name:'Batch', sel:false},
                    {name:'GLSL', sel:false},
                    {name:'HLSL', sel:false},
                    {name:'SQL', sel:false},
                ]
            },
            {
                cname:"Technology",
                tags:[
                    {name:'AI', sel:false},
                    {name:'Low-Level', sel:false},
                    {name:'Windows API', sel:false},
                    {name:'WebSocket', sel:false},
                    {name:'WASM', sel:false},
                    {name:'VueJS', sel:false},
                    {name:'Webpack', sel:false},
                    {name:'MIDI', sel:false},
                    {name:'NDI', sel:false},
                    {name:'DMX512', sel:false},
                    {name:'CI/CD', sel:false},
                    {name:'Postgres', sel:false},
                    {name:'Bootstrap', sel:false},
                    {name:'Spring Boot', sel:false},
                    {name:'MS Office Interop', sel:false},
                ]
            },
            {
                cname:"Graphics",
                tags:[
                    {name:'Vector', sel:false},
                    {name:'3D', sel:false},
                    {name:'2D', sel:false},
                    {name:'ASCII', sel:false},
                ]
            },
            {
                cname:"Distribution",
                tags:[
                    {name:'Open-Source', sel:false},
                    {name:'Closed-Source', sel:false},
                    {name:'Private', sel:false},
                    {name:'NDA', sel:false},
                ]
            },
        ])

        const ftogg = (gi, ci, tag) => {
            catlist.value[gi].tags[ci].sel = !catlist.value[gi].tags[ci].sel 
        }

        const plist = [
            {
                title: 'Interpolated UI Concept',
                links: [
                    ['GitHub','https://github.com/Alex-Dash/laginter-ui-concept','View on GitHub'],
                    ['GitHub','https://alex-dash.github.io/laginter-ui-concept/','Deployment']
                ],
                desc: 'PoC for using Lagrange\'s interpolation for UI purposes',
                tags: ['Software', 'PoC', 'HTML/CSS', 'JavaScript', 'Open-Source']
            },
            {
                title: 'Project "EM"',
                desc: 'Nation-wide high-load backend for a [REDACTED] monitoring and analytics, with granular access control.',
                tags: ['Software', 'Released', 'GO', 'HTML/CSS', 'JavaScript', 'WebSocket', 'SQL', 'Postgres', 'Closed-Source', 'Private', 'NDA']
            },
            {
                title: 'Codename "Conda"',
                desc: 'A stylized custom XR HMD made for live performances, integrating with Audio, Video and Lighting systems over industry standard protocols.',
                tags: ['Hardware', 'GO', 'WebSocket', 'Vector', 'GLSL', '3D', 'In Development']
            },
            {
                title: 'Project "MIMC"',
                desc: 'A turing-complete scriptable event system with MIDI and NDI support for OBS. Remotely controllable, with flexible multi-server multi-client setup and granular access control.\nFor advanced live-streaming setups.',
                tags: ['Software', 'In Development', 'GO', 'VueJS', 'Webpack', 'HTML/CSS', 'JavaScript', 'Low-Level', 'MIDI', 'NDI', 'WebSocket', 'Open-Source']
            },
            {
                title: 'OPI Software PWM',
                img: 'https://github.com/Alex-Dash/opi-fanpwm/raw/master/assets/orange_pi_pc2_pinout.png',
                links: [
                    ['GitHub','https://github.com/Alex-Dash/opi-fanpwm','View on GitHub']
                ],
                desc: 'A simple python script to control a PWM fan for cooling my DNS server.',
                tags: ['Software', 'Released', 'Python', 'Open-Source']
            },
            {
                title: 'PayShop3',
                img: 'https://raw.githubusercontent.com/Alex-Dash/payshop3/master/media/s1.png',
                links: [
                    ['GitHub','https://github.com/Alex-Dash/payshop3','View on GitHub']
                ],
                desc: 'An interactive order-based system for buying assets for PayDay3.\nDeveloped for console use',
                tags: ['Software', 'Released', 'GO', 'Open-Source']
            },
            {
                title: 'Flipper TOTP converter',
                // img: 'https://raw.githubusercontent.com/Alex-Dash/payshop3/master/media/s1.png',
                links: [
                    ['GitHub','https://github.com/Alex-Dash/flip-totp-converter','View on GitHub'],
                    ['GitHub','https://alex-dash.github.io/flip-totp-converter/','Deployment'],
                ],
                desc: 'This client side web application reads export data from popular totp/authenticator apps and makes it compatible with Flipper Zero',
                tags: ['Software', 'Released', 'JavaScript', 'HTML/CSS', 'Open-Source', 'Vector']
            },
            {
                title: 'Twitch Bits Game',
                desc: 'A pokemon-lookalike procedural 3D battle generator and player tied to Twitch donations, integrated as a stream overlay with external leaderboards and inventory tracking.',
                tags: ['Software', 'Archived', 'Closed-Source', 'JavaScript', 'HTML/CSS', 'NodeJS', 'Postgres', 'WebSocket', '3D', '2D', 'Vector', 'Private']
            },
            {
                title: 'LX-Chat',
                desc: 'Interactive and infinitely customizable Twitch chat overlay with external emotes support and limited auto-moderation features in a neat single file package.',
                tags: ['Software', 'Archived', 'Closed-Source', 'JavaScript', 'HTML/CSS', 'WebSocket']
            },
            {
                title: 'L3RD',
                desc: 'Remote-control, procedural graphics generation, lower-3rd generation, tournament system and predictive analytics display for Twitch channels and Twitch-hosted events.',
                tags: ['Software', 'Archived', 'Closed-Source', 'JavaScript', 'HTML/CSS', 'NodeJS', 'GO', 'Postgres', 'WebSocket', '2D', '3D', 'Vector', 'Private']
            },
            {
                title: 'POtG',
                desc: 'A procedurally generated clone of Overwatch 2 "Play Of the Game" screen for multiple Twitch Gift-sub events.',
                tags: ['Software', 'Archived', 'Closed-Source', 'JavaScript', 'HTML/CSS', 'NodeJS', 'Postgres', 'WebSocket', '2D', 'Vector', 'Private']
            },
            {
                title: 'OSC Twitch Integration builder',
                desc: 'A customizable OSC server, triggered by redeems or messages in Twitch.',
                tags: ['Software', 'Archived', 'Closed-Source', 'GO', 'OSC', 'WebSocket']
            },
            {
                title: 'Twitch HypeTrain Renderer',
                desc: 'A procedurally generated stream overlay for Twitch HypeTrain events with external leaderboards.',
                tags: ['Software', 'Archived', 'Closed-Source', 'HTML/CSS', 'JavaScript', 'NodeJS', 'WebSocket', 'Postgres', 'Private']
            },
            {
                title: 'StatGrep',
                desc: 'Large scale Twitch statistics scraper.',
                tags: ['Software', 'Archived', 'Closed-Source', 'NodeJS', 'Python', 'Private']
            },
            {
                title: 'StatMap',
                desc: 'A customizable per stream Twitch statistics tracking and analytics.',
                tags: ['Software', 'Archived', 'Closed-Source', 'GO', 'Python', 'Private']
            },
            {
                title: 'Guardian Engine',
                desc: 'NLP based automatic moderation tool and bot-raid protection for Twitch',
                tags: ['Software', 'Archived', 'Closed-Source', 'NodeJS', 'Python', 'Private', 'AI']
            },
            {
                title: 'Timepad Ticket Decryptor',
                // img: 'https://raw.githubusercontent.com/Alex-Dash/payshop3/master/media/s1.png',
                links: [
                    ['GitHub','https://github.com/Alex-Dash/timepad-ticket-decryptor','View on GitHub'],
                ],
                desc: 'A web-based decryptor of event data for Timepad tickets.',
                tags: ['Software', 'PoC', 'JavaScript', 'GO', 'HTML/CSS', 'WASM', 'Open-Source', 'Vector']
            },
            {
                title: 'MLG-Fetch',
                // img: 'https://raw.githubusercontent.com/Alex-Dash/payshop3/master/media/s1.png',
                desc: 'Social media scrapper and report generator.',
                tags: ['Software', 'Released', 'Private', 'NDA', 'C#', 'MS Office Interop']
            },
            {
                title: 'Lebaston\'s MIDItoOBS',
                // img: 'https://raw.githubusercontent.com/Alex-Dash/payshop3/master/media/s1.png',
                desc: '[Contributor] A small script to use a midi input device to control basic OBS-Studio functions ',
                tags: ['Software', 'Released', 'Python', 'Open-Source', 'MIDI', 'WebSocket']
            },
        ]

        if(props.tags){
            if(props.tags?.length>0){
                let src_tags = props.tags.map(e=>e.toLowerCase())
                for (const cat of catlist.value) {
                    for (const tag of cat.tags) {
                        if(src_tags.includes(tag.name.toLowerCase())){
                            tag.sel = true
                        }
                    }
                }
            }
        }

        const plsearch = ref('')

        const f_plist = computed(()=>{
            let ret = [...plist]
            for (const cat of catlist.value) {
                if(cat.tags.some(e=>e.sel)){
                    // filter by cat
                    let ctags = cat.tags.filter(e=>e.sel)
                    ret = ret.filter(pj=>pj.tags.some(tg=>ctags.map(ct=>ct.name.toLowerCase()).includes(tg.toLowerCase())))
                }
            }
            if (plsearch.value.trim().length>0) {
                // filter by name
                let s = plsearch.value.trim().toLowerCase()
                ret = ret.filter(x=>(x.title.toLowerCase().includes(s) || x.desc.toLowerCase().includes(s)))
            }
            return ret
        })

        const fadd = (tag) =>{
            let t = tag.trim().toLowerCase()
            for (const cat of catlist.value) {
                for (const tgt_tag of cat.tags) {
                    if(tgt_tag.name.trim().toLowerCase()===t){
                        tgt_tag.sel = true
                    }
                }
            }
        }

        return {plist, catlist, ftogg, f_plist, plsearch, fadd}
    },
}
</script>
<style>
    @media screen and (max-width: 50em){
        /* Small screens */
        .pl-cards{
            display: flex;
            flex-direction:column;
            align-items: center;
            width: 100%;
            overflow-y: auto;
            overflow-x: hidden;
            max-height: 100vh;
        }
        .project-list{
            display:flex;
            justify-content: center;
            align-content: center;
            align-items: center;
            flex-direction: column;
        }
        .pl-content{
            display:flex;
            flex-direction: column;
            justify-content: center;
            align-content: center;
            align-items: center;
            flex-direction: column;
        }
    }
    @media screen and (min-width: 50em){
        .pl-cards{
            display: flex;
            flex-direction: row;
            flex-wrap: wrap;
            width: 50vw;
            min-width: 15em;
            max-height: 100vh;
            overflow-y: auto;
            overflow-x: hidden;
            justify-content: space-around;
        }    
        .project-list{
            display:flex;
            justify-content: center;
            align-content: center;
            align-items: center;
            flex-direction: column;
        }
        .pl-content{
            display: flex;
            flex-direction: row;
            width: 100%;
        }
    }

    .pl-cat-title{
        width: 100%;
        display: flex;
        justify-content: center;
        font-size: 1.5em;
        font-weight: 600;
        color: rgb(180, 180, 180);
        margin-bottom: 0.2em;
        margin-top: 0.5em;
    }

    .pl-search{
        width: 100%;
    }

    .pl-search input{
        width: 100%;
        padding: 0.3em 0.7em;
        font-family: "Ubuntu Mono", monospace;
        font-size: 1.3em;
        margin-bottom: 0.5em;
    }

    .pl-title{
        font-size: 2em;
    }

    .pl-search input:hover{

    }

    .pl-search input:active, .pl-search input:focus{
        outline:none;
    }

    .pl-taglist{
        max-width:18em;
        border-right: solid white 0.1em;
        border-left: solid white 0.1em;
        border-radius: 0.4em;
        overflow: hidden;
        padding: 1em;
        height: fit-content;
    }
    .pl-cat-tags{
        display: flex;
        flex-direction:row;
        flex-wrap: wrap;
    }
    .pl-cat-tag-toggle{
        font-weight: 600;
        background: rgba(60,60,60,0.7);
        padding: 0.1em 0.4em;
        border-radius: 1em;
        margin: 0.2em;
        width: fit-content;
        cursor: pointer;
        transition: 
            background 200ms, 
            color 200ms,
            transform 100ms;
    }
    
    .pl-cards>div{
        margin: 0.5em;
    }

    .pl-notfound{
        width: 100%;
        display: flex;
        justify-content: center;
        color: rgb(140,140,140);
        font-size: 2em;
        font-style: italic;
    }

    .pl-cat-tag-toggle:hover, .pl-cat-tag-toggle:active{
        background: rgba(220,220,220,0.7);
        color: rgba(60,60,60,1);
    }

    .pl-cat-tag-toggle:active{
        transform: scale(0.9);
    }

    .pl-tag-sel{
        background: rgb(1, 159, 159);
    }

    .p-card{
        height: fit-content;
    }

    .pl-tag-sel:hover{
        background: rgb(1, 60, 60);
        color: rgba(200,200,200,1);
    }
</style>